<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="text-h5">刪除帳號</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div class="text-body-1">
          確定要刪除帳號
          <span class="font-weight-bold teal--text">{{ accountName }}</span>
          嗎？
        </div>
        <div class="mt-2 error--text">
          此操作無法撤銷。
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">
          取消
        </v-btn>
        <v-btn
          color="error"
          dark
          @click="handleDelete"
        >
          刪除
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * AccountDeleteDialog - 刪除帳號確認 Dialog
 *
 * Props:
 * - value: Dialog 開關狀態（v-model）
 * - account: 要刪除的帳號物件
 *
 * Events:
 * - input: Dialog 開關變更
 * - confirm: 確認刪除
 */
export default {
  name: 'AccountDeleteDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object,
      default: null
    }
  },
  computed: {
    accountName() {
      return this.account ? this.account.name : ''
    }
  },
  methods: {
    handleDelete() {
      this.$emit('confirm', this.account)
    }
  }
}
</script>
